"use client";

import { paymentEndpoints, getBaseUrl, getAuthHeader } from "../payment-config";

export interface YooKassaTokenRequest {
  idempotenceKey: string;
  amount: number;
  tokenCount: number;
  description: string;
}

export class YooKassaService {
  async generateToken(request: YooKassaTokenRequest): Promise<string> {
    const baseUrl = getBaseUrl();
    const apiUrl = `${baseUrl}${paymentEndpoints.yookassa.generateToken}`;

    const authHeader = await getAuthHeader();

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...authHeader,
      },
      body: JSON.stringify({
        IdempotenceKey: request.idempotenceKey,
        Amount: request.amount,
        TokenCount: request.tokenCount,
        Description: request.description,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("YooKassa API error:", errorText);
      throw new Error(
        `HTTP error! status: ${response.status}, body: ${errorText}`
      );
    }

    const responseData = await response.json();

    // API returns the token directly as a string, not as an object
    if (typeof responseData === "string") {
      return responseData;
    }

    // Fallback: check if it's an object with confirmation_token field
    if (responseData.confirmation_token) {
      return responseData.confirmation_token;
    }

    throw new Error("No confirmation_token received from YooKassa API");
  }
}

export const yooKassaService = new YooKassaService();
